// src/App.js
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import ScrollToTop from "./components/ScrollToTop";
import LogoWhatsApp from "./components/WhatsAppButton";
import NavBar from "./components/NavBar";
import DropdownMenu from "./components/DropdownMenu";
import Home from "./components/Home";
import Mudanzas from "./components/Mudanzas";
import Guardamuebles from "./components/Guardamuebles";
import Contacto from "./components/Contacto";
import Footer from "./components/Footer";
import Form from "./components/Form";

function App() {
  return (
    <div className="app-container">
      <Router>
        <ScrollToTop />
        <NavBar />
        <DropdownMenu />
        <div className="routes-container">
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Home />
                  <Form />
                  <Footer />
                </>
              }
            />
            <Route
              path="/mudanzas"
              element={
                <>
                  <Mudanzas />
                  <Footer />
                </>
              }
            />
            <Route
              path="/guardamuebles"
              element={
                <>
                  <Guardamuebles />
                  <Footer />
                </>
              }
            />
            <Route
              path="/contacto"
              element={<Contacto />}
            />
            {/* No hay Footer en esta ruta */}
            <Route
              path="/button-form"
              element={
                <>
                  <Form />
                  <Footer />
                </>
              }
            />
          </Routes>
        </div>
      </Router>
      <LogoWhatsApp />
    </div>
  );
}

export default App;
